var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('FilesTable',{attrs:{"moduleName":"customer","moduleId":_vm.tempCustomer.id,"customerId":_vm.tempCustomer.id,"s3Folder":"customers","searchCustomerId":`${_vm.tempCustomer.id}`}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }